import React from 'react';
import CertificationsCarousel from './CertificationsCarousel';

const CertificationsSection = ({
  id = 'certifications',
  sectionClassName = 'rihen-section certifications-section',
  showIntroHeader = true,
  introEyebrow,
  introTitle,
  introTitleLine2,
  introTitleClassName = 'hero-manifest__title hero-manifest__title--on-surface',
  introSubtitle,
}) => (
  <section className={sectionClassName} id={id}>
    <div className="rihen-site-inner">
      <CertificationsCarousel
        showIntroHeader={showIntroHeader}
        introEyebrow={introEyebrow}
        introTitle={introTitle}
        introTitleLine2={introTitleLine2}
        introTitleClassName={introTitleClassName}
        introSubtitle={introSubtitle}
      />
    </div>
  </section>
);

export default CertificationsSection;
